import * as types from '../types';

const app = {
  state: {
    olmap: {},
    chartType: {},
    mapSpecialName: '',
    mapTableData: [],
    mapCode: '2d',
    selectModal: [],
    setAreaCode: {
      activeIndex: 0,
      activeIndexC: -1,
      activeIndexQ: -1,
    },
    censusActivity: {
      policyPaper: {},
      notice: {},
      trainingCourse: {},
    },
    scrollTop: 0,
    oneMapToolBarList: {
      classification: [],
      administrative: [],
      grade: '',
      newDiscovery: '',
    },
    oneMapRouterAdd: false,
    oneMapRecommed: false,
    oneMapRegion: {
      Market: [],
      County: [],
    },
    refshe:false,
  },
  getters: {},
  mutations: {

    CHANGE_ROUTERADD(state, data) {
      state.oneMapRouterAdd = data;
    },
    CHANGE_RECOMMED(state, data) {
      state.oneMapRecommed = data;
    },
    CHANGE_ONEMAPTOOL(state, data) {
      console.log(data.value, 123);
      state.oneMapToolBarList[data.type] = data.value;
    },
    CHANGE_RECOMMED(state, data) {
      state.oneMapRegion[data.type] = data.value;
    },
    SET_SCROLLTOP(state, value) {
      state.scrollTop = value;
    },
    setPolicyPaper(state, data) {
      state.censusActivity['policyPaper'] = data;
    },
    setNotice(state, data) {
      state.censusActivity['notice'] = data;
    },
    setTrainingCourse(state, data) {
      state.censusActivity['trainingCourse'] = data;
    },
    setMapData(state, mapCode) {
      state.mapCode = mapCode;
    },
    setAreaCode(state, data) {
      state.setAreaCode = data;
    },
    setOrder(state, data) {
      state.refshe = data;
    },
    setTMDLayer(state, data) {
      // 与setToolData类似
      state.selectModal = data;
    },
    [types.OLMAP_BASEMAPINIT](state, omap) {
      state.olmap = { x: 's' };
    },
    [types.OLMAP_CHARTTYPE](state, a) {
      state.chartType = a;
    },
    [types.OLMAP_MAPSPECIAL](state, name) {
      state.mapSpecialName = name;
    },
    [types.OLMAP_MAPTABLETYPE](state, data) {
      state.mapTableData = data;
    },
  },
  actions: {},
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js